import { put, call, takeEvery } from 'typed-redux-saga';
import CustomerTransferGateway from '~apis/customerTransfer';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { MetalTypeEnum, TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchGetPendingCustomerTransferListing(api: CustomerTransferGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalGetPendingCustomerTransferListingAttempt', handleGetPendingCustomerTransferListing, api);
}

function* handleGetPendingCustomerTransferListing(api: CustomerTransferGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            branchName,
            metalType,
            senderName,
            senderIdNo,
            receiverName,
            receiverIdNo,
            productName,
            productId,
            status,
            dateFrom,
            dateTo,
        },
    } = reduxState.approval.pendingCustomerTransferListing;

    const allBranches = reduxState.branch.allBranches;

    const branchCode = allBranches.find(branch => branch.branchName === branchName)?.branchCode;

    if (!index && index !== 0) {
        yield put(combinedActions.approvalGetPendingCustomerTransferListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getCustomerTransferListing], {
        authToken,
        index,
        senderName: senderName ? senderName : undefined,
        senderIdNo: senderIdNo ? senderIdNo : undefined,
        receiverName: receiverName ? receiverName : undefined,
        receiverIdNo: receiverIdNo ? receiverIdNo : undefined,
        productId: productId ? productId : undefined,
        status: status ? UtilFunctions.Misc.getEnumValueByKey(TransactionStatusEnum, status) : undefined,
        dateFrom: dateFrom ? dateFrom : undefined,
        dateTo: dateTo ? dateTo : undefined,
        branchCode: branchCode ? branchCode : undefined,
        metalType: metalType ? UtilFunctions.Misc.getEnumValueByKey(MetalTypeEnum, metalType.split(' ').join('')) : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalGetPendingCustomerTransferListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalGetPendingCustomerTransferListingSuccess(response.data));
    }
}
